import type { CityConfig } from "../city-template/types";

export const kentConfig: CityConfig = {
  city: "Kent",
  state: "Washington",
  stateAbbr: "WA",
  slug: "kent",
  route: "/kent",
  title: "Emergency Passport Kent WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Kent, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Kent, Renton, Auburn, and all South King County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Kent, WA",
  heroSubtitle: "Kent travelers — from Green River Valley logistics hub workers to diverse South King County families to Boeing Field corridor professionals — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Kent, the Kent Valley, and South King County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Kent%20Washington%20in%20the%20Green%20River%20Valley%20of%20South%20King%20County%2C%20Kent%20Station%20retail%20and%20transit%20hub%2C%20the%20Green%20River%20winding%20through%20the%20valley%20with%20industrial%20and%20warehouse%20districts%2C%20residential%20neighborhoods%20with%20Mount%20Rainier%20visible%20on%20the%20horizon%2C%20Boeing%20Field%20corridor%20nearby%2C%20diverse%20suburban%20landscape%20with%20Pacific%20Northwest%20greenery%2C%20warm%20golden%20afternoon%20sunlight%2C%20South%20King%20County%20logistics%20hub%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=kent-hero-001&orientation=landscape",
  heroImageAlt: "Kent Washington Green River Valley South King County with Mount Rainier",
  geoPosition: "47.3810;-122.2345",
  geoPlacename: "Kent, Washington",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "Approximately 18 miles north of Kent via I-5 or SR-167",
  },
  nearbyCitiesZips: [
    { name: "Kent", zips: "98030, 98031, 98032, 98035, 98042, 98064, 98089" },
    { name: "Renton", zips: "98055, 98056, 98057, 98058, 98059" },
    { name: "Auburn", zips: "98001, 98002, 98092, 98071" },
    { name: "Federal Way", zips: "98003, 98023, 98063, 98093" },
    { name: "Des Moines", zips: "98148, 98158, 98198" },
    { name: "SeaTac", zips: "98148, 98158, 98168, 98188, 98198" },
    { name: "Tukwila", zips: "98108, 98138, 98168, 98178, 98188" },
    { name: "Burien", zips: "98146, 98148, 98166, 98168" },
    { name: "Covington", zips: "98042" },
    { name: "Maple Valley", zips: "98038" },
    { name: "Black Diamond", zips: "98010" },
    { name: "Ravensdale", zips: "98051" },
    { name: "Hobart", zips: "98025" },
    { name: "Enumclaw", zips: "98022" },
    { name: "Pacific", zips: "98047" },
    { name: "Algona", zips: "98001" },
    { name: "Milton", zips: "98354" },
    { name: "Edgewood", zips: "98371, 98372, 98390" },
    { name: "Normandy Park", zips: "98148, 98166" },
    { name: "Puyallup", zips: "98371, 98372, 98373, 98374, 98375" },
    { name: "Tacoma", zips: "98402, 98403, 98404, 98405" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — just 20 minutes north via I-5 or SR-167" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-truck-line", title: "South King County Logistics Hub", desc: "Serving Kent, Renton, Auburn, Covington, and all of the Green River Valley" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Kent or South King County location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Seattle, WA", route: "/seattle" },
    { name: "Emergency passport help in Renton, WA", route: "/renton" },
    { name: "Urgent passport services in Federal Way, WA", route: "/federal-way" },
    { name: "Washington passport services overview", route: "/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Kent, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — approximately 20 minutes north via I-5 or SR-167. Kent residents can ship from any UPS or FedEx in South King County.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Kent, Renton, Auburn, Covington, Maple Valley, Federal Way, Des Moines, and all of South King County and the Green River Valley",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Kent and South King County. From Kent Station and the downtown retail hub to the warehouse and logistics corridor along the Green River, from the residential neighborhoods of East Hill and the Kent Valley to the suburban communities of Covington and Maple Valley — we serve all of Kent and the South King County region.",
  nearbyCitiesIntro: "We serve Kent and all nearby communities including Renton, Auburn, Federal Way, Des Moines, SeaTac, Tukwila, Covington, Maple Valley, and Enumclaw. We also serve Burien, Pacific, Algona, Milton, and north Pierce County. Our service covers the entire South King County corridor.",
  howItWorksIntro: "Most Kent travelers complete everything online and ship documents overnight. No need to drive 20 minutes north on I-5 or SR-167 to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Kent is a diverse South King County city and a major logistics hub in the Green River Valley with Boeing Field corridor access. Here are the most common passport mistakes we see from Kent-area travelers.",
  testimonialsIntro: "Kent travelers — from Green River Valley workers to South King County families to diverse community members — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Kent, WA? Here are the most common ones we hear from South King County travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (WA DOH)", url: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records", desc: "Washington State Department of Health — Center for Health Statistics for birth and death certificates statewide" },
    { label: "Marriage Licenses (King County Recorder)", url: "https://www.kingcounty.gov/depts/records-licensing.aspx", desc: "King County Recorder's Office — marriage license applications and certified copies for Kent and South King County" },
    { label: "Divorce Decrees (King County Superior Court)", url: "https://www.kingcounty.gov/courts/superior-court.aspx", desc: "King County Superior Court — divorce decree records for Kent and South King County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Washington birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close I-5 corridor proximity", "No I-5/SR-167 traffic or downtown parking hassle", "Perfect for South King County travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close I-5 corridor proximity", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to downtown Seattle", "I-5/SR-167 traffic and downtown parking"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Kent travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Seattle Passport Agency. Perfect for South King County families, logistics industry travel, and last-minute international departures.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — I-5/SR-167 corridor courier", "South King County family and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Kent adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your South King County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Kent residents and families — including diverse community members, logistics workers, and South King County residents.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Kent residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Kent and South King County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Kent and South King County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Kent WA", description: "Urgent passport processing for Kent Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Kent WA", description: "Fast passport renewal for Kent Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Kent WA", description: "New passport application services for Kent Washington residents applying for their first passport." },
    { name: "Child Passport Kent WA", description: "Minor passport services for Kent Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Ahmed R.",
      location: "Kent, WA",
      rating: 5,
      text: "Family reunion in Morocco with 7 days notice and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Kent Kangley Road and the whole process was seamless. Outstanding service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Kim & James P.",
      location: "Covington, WA",
      rating: 5,
      text: "Trip to the Philippines with 10 days notice. Three passports — one adult renewal and two first-time for our kids. Done in 5 days. We shipped from FedEx in Kent and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Luis M.",
      location: "Auburn, WA",
      rating: 5,
      text: "Business trip to Mexico City with 8 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is especially valuable for South King County's diverse business community.",
      service: "Emergency Passport",
    },
    {
      name: "Sandra L.",
      location: "Maple Valley, WA",
      rating: 5,
      text: "Lost my passport two weeks before a trip to Korea. Fast Passport Center replaced it in 4 days. The proximity to Kent Station made shipping documents incredibly easy.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "ket-1",
      name: "Kent Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10612 SE 240th St",
      city: "Kent",
      state: "WA",
      zip: "98031",
      phone: "(253) 852-3301",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Kent, near Kent Station and downtown Kent",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Kent acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Kent Station, downtown Kent, and the Green River Valley corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "ket-2",
      name: "Renton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17200 116th Ave SE",
      city: "Renton",
      state: "WA",
      zip: "98058",
      phone: "(425) 226-3955",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Renton, approximately 7 miles north of downtown Kent",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for north Kent and Renton residents. Near The Landing retail area and Boeing Renton plant.",
      icon: "ri-mail-line",
    },
    {
      id: "ket-3",
      name: "Auburn Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11 3rd St NW",
      city: "Auburn",
      state: "WA",
      zip: "98001",
      phone: "(253) 939-8658",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Auburn, approximately 7 miles south of downtown Kent",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Auburn, Algona, Pacific, and south Kent residents. Good alternative for south county travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "ket-4",
      name: "Federal Way Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "32925 1st Ave S",
      city: "Federal Way",
      state: "WA",
      zip: "98003",
      phone: "(253) 838-4812",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Federal Way, approximately 7 miles west of downtown Kent",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Federal Way and west Kent area. Good alternative for west Kent residents near the I-5 corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "ket-5",
      name: "King County Clerk — Seattle",
      type: "County Clerk Passport Acceptance",
      address: "516 3rd Ave, Room W-105",
      city: "Seattle",
      state: "WA",
      zip: "98104",
      phone: "(206) 477-3080",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Seattle Courthouse — approximately 20 minutes north via I-5",
      website: "https://www.kingcounty.com/depts/courts/clerk.aspx",
      websiteLabel: "King County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to post office. Kent residents may prefer the Kent, Renton, or Auburn post offices for convenience.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — I-5/SR-167 traffic to downtown Seattle", fpc: "No — ship from Kent" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "South King County Advantage", agency: "No special guidance", fpc: "Yes — Kent Valley and logistics corridor expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Kent logistics workers and South King County families often discover passport issues just before international shipments and family travel. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services at Kent Station or along West Valley Highway sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at King County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Kent Post Office appointments fill during summer and around the holiday shopping season at Kent Station. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Choosing Between I-5 and SR-167 for the Agency Drive",
      description: "Many Kent residents attempt to drive to the Seattle passport agency. I-5 is typically faster but more congested; SR-167 to I-405 is an alternative. Either route can take 30–60+ minutes in rush hour. Our courier service eliminates route planning entirely.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. South King County's growing and diverse population creates steady year-round passport demand — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Kent area or South King County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Kent, Renton, or Auburn." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need to navigate I-5 or SR-167 yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kent address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Kent, WA?", a: "Fast Passport Center offers emergency passport processing in Kent, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — approximately 20 minutes north via I-5 or SR-167." },
    { q: "Does Kent have its own passport agency?", a: "No — Kent does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 20 minutes north via I-5 or SR-167). Fast Passport Center's courier service means Kent residents never need to deal with South King County traffic and downtown Seattle parking." },
    { q: "Can I get an expedited passport in Renton, Auburn, or Covington?", a: "Absolutely. Fast Passport Center serves all of South King County including Renton, Auburn, Covington, Maple Valley, Federal Way, and all surrounding communities. Our service works the same way everywhere." },
    { q: "What airport do Kent travelers use for international flights?", a: "Seattle-Tacoma International Airport (SEA) is the primary airport — approximately 15 minutes from Kent via SR-518 or I-5. SEA is very close to Kent and offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Always verify passport validity for at least 6 months past your return date." },
    { q: "Why is Kent known as a logistics hub?", a: "Kent's location in the Green River Valley — between Seattle and Tacoma with direct access to I-5, SR-167, and SEA Airport — has made it one of the largest warehouse and distribution corridors in the Pacific Northwest. Amazon, Boeing, REI, and many others operate major facilities here. This also means many Kent residents work in industries with international supply chain connections and travel needs." },
    { q: "How much does an expedited passport cost in Kent, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Kent?", a: "Walgreens, CVS, and Rite Aid stores throughout Kent offer passport photos. UPS Store and FedEx Office locations at Kent Station and along the West Valley Highway also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the Boeing Field corridor near Kent?", a: "Yes. Fast Passport Center serves all of South King County including the Boeing Field corridor (BFI), the Green River Valley warehouse district, and the businesses and families that make Kent one of the most diverse and industrially significant cities in Washington." },
  ],
  photoLocations: [
    { name: "Walgreens — Kent Kangley Road", address: "26006 104th Ave SE, Kent, WA 98030", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Rite Aid — West Valley Highway", address: "24050 Pacific Hwy S, Kent, WA 98032", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Kent Station", address: "222 1st Ave S, Kent, WA 98032", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Renton", address: "1780 Union Ave SE, Renton, WA 98055", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "WA DOL — Kent", address: "25410 74th Ave S, Kent, WA 98032", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Located in the heart of the Green River Valley. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Renton", address: "1314 Union Ave NE, Renton, WA 98059", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves north Kent and Renton. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "15 minutes from Kent via SR-518 or I-5",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary airport for Kent and South King County. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub. Kent's location in the Green River Valley gives it very fast airport access — one of the closest South King County cities to SEA.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: true,
    },
    {
      code: "BFI",
      name: "King County International Airport (Boeing Field)",
      distance: "Approximately 15 minutes north via I-5 or SR-167",
      address: "7277 Perimeter Rd S, Seattle, WA 98108",
      note: "General aviation and cargo airport adjacent to the Kent logistics corridor. Serves Boeing and corporate aviation. Kent's warehouse and distribution industry has direct connections to BFI cargo operations.",
      flightUrl: "https://www.kingcounty.gov/depts/transportation/kcia.aspx",
      flightLabel: "BFI Info",
      featured: false,
    },
  ],
};